import PropTypes from 'prop-types';
import HeaderToggle from './HeaderToggle';
import HeaderDate from './HeaderDate';
import HeaderActions from './HeaderActions';
import { useSidebarContext } from './SidebarContext';

export default function Header({ onToggleSidebar, sidebarOpen }) {
  const { isCompact } = useSidebarContext();

  return (
    <div
      className={`flex items-center justify-between border-b border-gray-200 bg-white px-4 py-3 sm:px-6 sm:py-4 fixed top-0 left-0 right-0 z-30 h-16 transition-all duration-300 ${
        sidebarOpen ? (isCompact ? 'lg:left-10' : 'lg:left-60') : 'lg:left-0'
      }`}
    >
      <div className="flex items-center gap-3">
        {onToggleSidebar && <HeaderToggle isOpen={sidebarOpen} onClick={onToggleSidebar} />}
        <HeaderDate />
      </div>
      <HeaderActions />
    </div>
  );
}

Header.propTypes = {
  onToggleSidebar: PropTypes.func,
  sidebarOpen: PropTypes.bool,
};

Header.defaultProps = {
  sidebarOpen: true,
};
